import type { BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import { MARKER_JOIN_MS } from "../../marker/MarkerPresence/presence";
import { forkCurveSpan, joinCurveSpan } from "../../rail/RailLanes/lanes";

const CURVE_STEPS = 8;

/** Times where stay, branch, or beat boundaries can change poses. */
export function collectKeyframeTimesMs(layout: BookTimelineLayout): number[] {
  const times = new Set<number>([0]);
  for (const beat of layout.beats) {
    times.add(beat.startMs);
    times.add(Math.max(beat.startMs, beat.endMs - 1));
  }
  for (const stay of layout.rail.stays) {
    times.add(stay.startMs);
    times.add(Math.max(stay.startMs, stay.endMs - 1));
    const duration = stay.endMs - stay.startMs;
    if (duration > MARKER_JOIN_MS * 2) {
      times.add(stay.startMs + MARKER_JOIN_MS);
      times.add(stay.endMs - MARKER_JOIN_MS);
    }
  }
  for (const branch of layout.rail.branches) {
    times.add(branch.startMs);
    times.add(Math.max(branch.startMs, branch.endMs - 1));
    // Enough points along each curve for someone riding it to follow its shape.
    const spans = [
      ...(branch.forkFromLane === undefined ? [] : [forkCurveSpan(branch)]),
      ...(branch.joinToLane === undefined ? [] : [joinCurveSpan(branch)]),
    ];
    for (const span of spans) {
      for (let step = 0; step <= CURVE_STEPS; step++) {
        times.add(Math.max(0, span.startMs + ((span.endMs - span.startMs) * step) / CURVE_STEPS));
      }
    }
  }
  return [...times].sort((a, b) => a - b);
}
